import React, { useState, useEffect } from 'react'
import axios from 'axios'
import styled from 'styled-components'
import PageTitle from '../../_Components/Common/PageTitle/PageTitle'
import Preview from './Preview'
import EditTable from './EditTable'
import Dropdown from '../NewApp/Dropdown'

const Onboarding = () => {
  const [lang, setLang] = useState('en')
  const [category, setCategory] = useState('Recommended')
  const [categoryList, setCategoryList] = useState([])
  const [assistantList, setAssistantList] = useState([])
  const [create, setCreate] = useState(false)
  const [gender, setGender] = useState('all')

  const langList = [
    { code: 'en', lang: 'English' },
    { code: 'ko', lang: 'Korean' },
    { code: 'ja', lang: 'Japanese' },
    { code: 'zh-TW', lang: 'Traditional Chinese' },
    { code: 'zh-CN', lang: 'Simplified Chinese' },
    { code: 'es', lang: 'Spanish' },
    { code: 'pt', lang: 'Portuguese' },
    { code: 'id', lang: 'Indonesian' },
    { code: 'ms', lang: 'Malay' },
    { code: 'vi', lang: 'Vietnamese' },
    { code: 'th', lang: 'Thai' },
    { code: 'hi', lang: 'Hindi' },
    { code: 'ar', lang: 'Arabic' },
    { code: 'ru', lang: 'Russian' },
    { code: 'de', lang: 'German' },
    { code: 'fr', lang: 'French' },
    { code: 'it', lang: 'Italian' },
    { code: 'fil', lang: 'Filipino' },
    { code: 'mn', lang: 'Mongolian' },
  ]

  const genderList = ['all', 'male', 'female']

  useEffect(() => {
    getCategoryList()
  }, [])

  useEffect(() => {
    getOnboarding(lang, category, gender)
  }, [lang, category, gender])

  const getCategoryList = async () => {
    await axios
      .get(`/new/webAdmin/v2/assistant/category?menu=onboarding`, {
        headers: {
          token: sessionStorage.getItem('token'),
        },
      })
      .then(({ data }) => {
        console.log(data.result)
        setCategoryList(data.result)
      })
  }

  const getOnboarding = async (lang, category, gender) => {
    await axios
      .get(
        `/new/webAdmin/v2/assistant/onboarding?lang=${lang}&category=${category}&gender=${
          gender ? gender : 'all'
        }`,
        {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        }
      )
      .then(({ data }) => {
        console.log(data.result)
        setAssistantList(data.result)
      })
  }

  return (
    <>
      <PageTitle
        mainTitle={'Onboarding Assistant'}
        v1Link={''}
        navNames={['Onboarding']}
      />
      <SpaceResponsive height={10} />
      <Wrapper>
        <div style={{ height: '30px', margin: '15px 0', display: 'flex' }}>
          <div style={{ width: '10px' }} />
          <Dropdown
            list={langList}
            onChange={e => setLang(e.target.value)}
            value={lang}
            type={'lang'}
          />
          <div style={{ width: '10px' }} />
          <Dropdown
            list={categoryList}
            onChange={e => setCategory(e.target.value)}
            value={category}
            type={'category'}
          />
          <div style={{ width: '10px' }} />
          <Dropdown
            list={genderList}
            onChange={e => setGender(e.target.value)}
            value={gender}
            type={'page'}
          />
        </div>
        <div style={{ display: 'flex', columnGap: '16px' }}>
          <Preview assistantList={assistantList} />
          <EditTable
            assistantList={assistantList}
            lang={lang}
            category={category}
            create={create}
            setCreate={setCreate}
            getOnboarding={getOnboarding}
            gender={gender}
            langList={langList}
          />
        </div>
      </Wrapper>
    </>
  )
}

export default Onboarding

const SpaceResponsive = styled.div`
  height: ${props => props.height}px;
  flex-shrink: 0;
`

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  column-gap: 16px;
  padding: 0 15px;
  box-sizing: border-box;
`
